import { cardSchemesConstants } from "../constants/action.constants";

const initialState = {
  fetching: false,
  fetched: false,
  request: null,
  response: null,
  error: null
};

export const viewCardScheme = (state = initialState, action) => {
  switch (action.type) {
    case cardSchemesConstants.VIEW_CARDSCHEME_REQUEST:
      return {
        ...state,
        fetching: true,
        fetched: false,
        request: action.id,
        response: null,
        error: null
      };
    case cardSchemesConstants.VIEW_CARDSCHEME_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response,
        error: null
      };
    case cardSchemesConstants.VIEW_CARDSCHEME_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched: false,
        response: null,
        error: action.error
      };
    case cardSchemesConstants.VIEW_CARDSCHEME_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
